import { Component, Injectable, ViewChild, OnInit } from '@angular/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatSidenav } from '@angular/material/sidenav';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { BehaviorSubject } from 'rxjs';
import { MenuEntry } from 'src/app/shared/entrys/menu.entry';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Router } from '@angular/router';
import { MenuService } from '../../menu.service';
import { MenuTree } from 'src/app/shared/models/menu-tree.model';
import { OpcionesMenuEntry } from 'src/app/shared/entrys/opciones-menu.entry';

// const TREE_DATA_EXAMPLE = JSON.stringify({
// 	0: {
// 		descripcion: 'Configuración',
// 		opcion_modulo_id: 4,
// 		ruta_url: null,
// 		hijos: {
// 			0: {
// 				descripcion: 'Acción RNT',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/acciones-rnt',
// 				hijos: null
// 			},
// 			1: {
// 				descripcion: 'Actividades Económicas RNT',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/actividades-economicas-rnt',
// 				hijos: null
// 			},
// 			2: {
// 				descripcion: 'Campo Adicional',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/campo-adicional',
// 				hijos: null
// 			},
// 			3: {
// 				descripcion: 'Campo Adicional Categoría',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/campo-adicional-categoria',
// 				hijos: null
// 			},
// 			4: {
// 				descripcion: 'Categoría',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/categoria',
// 				hijos: null
// 			},
// 			5: {
// 				descripcion: 'Configuración Email Contáctenos',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/email-contactenos',
// 				hijos: null
// 			},
// 			6: {
// 				descripcion: 'Configuración Interfaz Inicial',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/interfaz',
// 				hijos: null
// 			},
// 			7: {
// 				descripcion: 'Configuración Tipo Interfaz',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/tipo-interfaz',
// 				hijos: null
// 			},
// 			8: {
// 				descripcion: 'Capacidad Técnica',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/configurar-capacidad',
// 				hijos: null
// 			},
// 			9: {
// 				descripcion: 'Contenido Certificado',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/contenido-certificado',
// 				hijos: null
// 			},
// 			10: {
// 				descripcion: 'Detalle Términos y Condiciones',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/detalle-terminos-condiciones',
// 				hijos: null
// 			},
// 			11: {
// 				descripcion: 'Documento',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/documento',
// 				hijos: null
// 			},
// 			12: {
// 				descripcion: 'Documento Subcategoría',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/documento-subcategoria',
// 				hijos: null
// 			},
// 			13: {
// 				descripcion: 'Documento Tipo Turismo Aventura',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/documento-tipo-turismo-aventura',
// 				hijos: null
// 			},
// 			14: {
// 				descripcion: 'Entorno',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/entorno',
// 				hijos: null
// 			},
// 			15: {
// 				descripcion: 'Estado RNT',
// 				opcion_modulo_id: 4,
// 				ruta_url: 'estado-rnt',
// 				hijos: null
// 			},
// 			16: {
// 				descripcion: 'Estado Solicitud',
// 				opcion_modulo_id: 4,
// 				ruta_url: 'estado-solicitud',
// 				hijos: null
// 			},
// 			17: {
// 				descripcion: 'FAQ',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/faq',
// 				hijos: null
// 			},
// 			18: {
// 				descripcion: 'FAQ Sección',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/faq-seccion',
// 				hijos: null
// 			},
// 			19: {
// 				descripcion: 'Formación Empleado',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/formacion-empleado',
// 				hijos: null
// 			},
// 			20: {
// 				descripcion: 'Legislación',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/legislacion',
// 				hijos: null
// 			},
// 			21: {
// 				descripcion: 'Módulo',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/modulo',
// 				hijos: null
// 			},
// 			22: {
// 				descripcion: 'Módulo Encuesta',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/modulo-encuesta',
// 				hijos: null
// 			},
// 			23: {
// 				descripcion: 'Módulo Encuesta Subcategoría',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/modulo-encuesta-subcategoria',
// 				hijos: null
// 			},
// 			24: {
// 				descripcion: 'Motivo de Devolución',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/motivo-devolucion',
// 				hijos: null
// 			},
// 			25: {
// 				descripcion: 'Opción Módulo',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/opcion-modulo',
// 				hijos: null
// 			},
// 			26: {
// 				descripcion: 'Opción Respuesta Adicional Encuesta',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/opcion-respuesta-adicional-encuesta',
// 				hijos: null
// 			},
// 			27: {
// 				descripcion: 'Opción Respuesta Encuesta',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/opcion-respuesta-encuesta',
// 				hijos: null
// 			},
// 			28: {
// 				descripcion: 'Opcion Rol',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/opcion-rol',
// 				hijos: null
// 			},
// 			29: {
// 				descripcion: 'Parámetro',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/parametro',
// 				hijos: null
// 			},
// 			30: {
// 				descripcion: 'Paso Solicitud',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/paso-solicitud',
// 				hijos: null
// 			},
// 			31: {
// 				descripcion: 'Paso Tipo Solicitud',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/paso-tipo-solicitud',
// 				hijos: null
// 			},
// 			32: {
// 				descripcion: 'Pregunta Adicional Encuesta',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/pregunta-adicional-encuesta',
// 				hijos: null
// 			},
// 			33: {
// 				descripcion: 'Pregunta Encuesta',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/pregunta-encuesta',
// 				hijos: null
// 			},
// 			34: {
// 				descripcion: 'Recurso Audiovisual',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/recurso-audiovisual',
// 				hijos: null
// 			},
// 			35: {
// 				descripcion: 'Rol',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/rol',
// 				hijos: null
// 			},
// 			36: {
// 				descripcion: 'Sección Encuesta',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/seccion-encuesta',
// 				hijos: null
// 			},
// 			37: {
// 				descripcion: 'Sub Categorias',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/subcategoria',
// 				hijos: null
// 			},
// 			38: {
// 				descripcion: 'Subcategorías Topes MLV',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/subcategorias-topesmlv',
// 				hijos: null
// 			},
// 			39: {
// 				descripcion: 'Término Condición',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/terminos-condiciones',
// 				hijos: null
// 			},
// 			40: {
// 				descripcion: 'Tipo Dato',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/tipo-dato',
// 				hijos: null
// 			},
// 			41: {
// 				descripcion: 'Tipo Identificación',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/tipo-identificacion',
// 				hijos: null
// 			},
// 			42: {
// 				descripcion: 'Tipo Pregunta Encuesta',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/tipo-pregunta-encuesta',
// 				hijos: null
// 			},
// 			43: {
// 				descripcion: 'Tipo Término Condición',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/tipo-terminos-condiciones',
// 				hijos: null
// 			},
// 			44: {
// 				descripcion: 'Documento Tipo Turismo Aventura',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/documento-tipo-turismo-aventura',
// 				hijos: null
// 			},
// 			45: {
// 				descripcion: 'Tipos RNT',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/tipos-rnt',
// 				hijos: null
// 			},
// 			46: {
// 				descripcion: 'Usuario',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/usuario',
// 				hijos: null
// 			},
// 			47: {
// 				descripcion: 'Usuario Rol',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/usuario-rol',
// 				hijos: null
// 			},
// 			48: {
// 				descripcion: 'Modulo Ayudas',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/modulo-ayuda',
// 				hijos: null
// 			}
// 		}
// 	},
// 	1: {
// 		descripcion: 'Gestión',
// 		opcion_modulo_id: 4,
// 		ruta_url: null,
// 		hijos: {
// 			0: {
// 				descripcion: 'Reasignar solicitudes',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/reasignacion',
// 				hijos: null
// 			},
// 			1: {
// 				descripcion: 'Cancelación Masiva',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/cancelacion',
// 				hijos: null
// 			},
// 			2: {
// 				descripcion: 'Suspensión Masiva',
// 				opcion_modulo_id: 4,
// 				ruta_url: '/admin/suspension',
// 				hijos: null
// 			}
// 		}
// 	},
// 	2: {
// 		descripcion: 'Informes',
// 		opcion_modulo_id: 4,
// 		ruta_url: '',
// 		hijos: null
// 	}
// });
@Component({
	selector: 'app-side-menu1',
	templateUrl: './side-menu1.component.html',
	styleUrls: ['./side-menu1.component.scss'],
})
export class SideMenu1Component implements OnInit {

  public year : number = Date.now();

	@ViewChild('sidenav', { static: false }) sidenav: MatSidenav;
	nestedTreeControl: NestedTreeControl<MenuTree>;
	nestedDataSource: MatTreeNestedDataSource<MenuTree>;

	reason = '';
	sideActive: boolean;
	userLogin: boolean;
	user_name: string;
	opcionesMenu: OpcionesMenuEntry;
	menuHorizontal: Array<MenuEntry>;
	close(reason: string) {
		this.reason = reason;
		this.sidenav.close();
	}

	constructor(private authService: AuthService,
		private router: Router, private menuService: MenuService) {
		this.nestedTreeControl = new NestedTreeControl<MenuTree>(this._getChildren);
		this.nestedDataSource = new MatTreeNestedDataSource();
		this.sideActive = true;
		this.userLogin = authService.isToken();
		this.opcionesMenu = this.menuService.getRoles();
	}

	navegacion(url: string) {
		this.router.navigate([url]);
	}
	hasNestedChild = (_: number, nodeData: MenuTree) => !nodeData.ruta_url;

	private _getChildren = (node: MenuTree) => node.hijos;

	ngOnInit() {
		this.user_name = this.authService.getUserNameToken();
		this.nestedDataSource.data = this.menuService.buildFileTree(this.opcionesMenu.vertical, 0);
		this.menuHorizontal = this.opcionesMenu.horizontal;
	}

	onClose() {
		this.authService.logout();
		this.router.navigate(['/home']);
	}


	goPagina(ruta_url: string) {
		this.router.navigate([ruta_url]);
	}

  onOLClick() {
		window.open('http://www.confecamaras.org.co');
	}
}

